import {
  AvailableTicketsListing,
  Background,
  DateNotAvailable,
  EventSaleCountdown,
  Cancelled,
  FullpageLoading,
  Menu,
  NotPublished,
  SoldOut,
  SalesClosed,
  TicketSettingsForm,
  WaitingRoom,
} from "components/index";
import messages from "i18n/messages";
import moment from "moment";
import first from "lodash/first";
import flowRight from "lodash/flowRight";
import {
  fetchDateById,
  fetchWaitingRoomVisitor,
  makeSelectDateById,
  makeSelectWaitingRoomVisitor,
  makeSelectResponseStatus,
} from "logic/dates";
import { makeSelectEventByDateId } from "logic/events";
import { makeSelectCurOrg } from "logic/orgs";
import { NextSeo } from "next-seo";
import Head from "next/head";
import Router, { withRouter } from "next/router";
import { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import { gtmTracking } from "lib/misc";

const clearLS = () => {
  localStorage.removeItem("ttp");
  localStorage.removeItem("ttpv");
  localStorage.removeItem("ttpc");
  localStorage.removeItem("tto");
  localStorage.removeItem("ttv");
  localStorage.removeItem("ttcus");
};

const basename = process.env.HZL_INST
  ? "https://ticket.theaterimpark.at"
  : "https://shop.ticketteer.com";

class EventIndex extends Component {
  static async getInitialProps(ctx) {
    const { id } = ctx.query;
    const wrToken = ctx.query["wrtk"];
    await ctx.store.dispatch(fetchDateById(id));
    await ctx.store.dispatch(fetchWaitingRoomVisitor(id, wrToken));
    return { pageProps: { id, wrToken } };
  }

  // getServerSideProps = (ctx) => {
  //   console.log(
  //     "date id",
  //     ctx.pageProps.date.id,
  //     ctx.pageProps.wrToken,
  //     ctx.pageProps.wrToken.match(/^tok_[0-9a-zA-|]{12}$/)
  //   );
  //   if (
  //     ctx.pageProps.date.id == "dat_5fbb95f574bdc0002dddaa27" &&
  //     (!ctx.pageProps.wrToken ||
  //       !ctx.pageProps.wrToken.match(/^tok_[0-9a-zA-|]{12}$/))
  //   ) {
  //     return {
  //       redirect: {
  //         destination: "/",
  //         permanent: false,
  //       },
  //     };
  //   }
  // };

  checkWRQueryString = () => {
    if (!this.props.visitor) return;
    if (this.props.visitor.pos < 1) return;

    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?wrtk=${this.props.visitor.token}`;

    if (history.pushState) {
      window.history.pushState({ path: newurl }, "", newurl);
      return;
    }
    window.location.href = newurl;
  };

  refreshWaitingRoomToken = (token) => {
    this.props.actions.fetchWaitingRoomVisitor(this.props.date.id, token);
    if (this.props.visitor && this.props.visitor.pos < 1) return;

    setTimeout(() => this.refreshWaitingRoomToken(token), 30 * 1000);
  };

  checkWaitingRoom = () => {
    if (typeof window === "undefined") return;
    if (this.props.org && this.props.org.portal && !this.props.org.portal.wr)
      return;

    this.checkWRQueryString();

    const token = this.props.visitor
      ? this.props.visitor.token
      : this.props.wrToken;
    if (this.props.visitor && this.props.visitor.pos < 1) return;

    setTimeout(() => this.refreshWaitingRoomToken(token), 30 * 1000);
  };

  componentDidMount() {
    this.checkWaitingRoom();
    this.checkCleanupPreviousOrders();
    gtmTracking(this.props.org, "ticketshop", "get-offer");
  }

  checkCleanupPreviousOrders = () => {
    // const tto = window.localStorage.getItem("tto");
    // if (tto) {
    //   try {
    //     const oldOrder = JSON.parse(tto);
    //     // if (oldOrder.id) apiDelete(`/book/${oldOrder.id}?token=${oldOrder.token}`)
    //   } catch (e) {
    //     console.log("ignoring failed deletion", e);
    //   }
    // }
    clearLS();
  };

  eventImgSrc = (event) =>
    event.images && first(event.images) ? first(event.images).full : null;

  eventBgImgstyles = (event) => ({
    backgroundImage: `url(${this.eventImgSrc(event)}`,
  });

  sharingOpts = () => {
    var width = 575,
      height = 400,
      left = (window.innerWidth - width) / 2,
      top = (window.innerHeight - height) / 2;
    return (
      "status=1" +
      ",width=" +
      width +
      ",height=" +
      height +
      ",top=" +
      top +
      ",left=" +
      left
    );
  };

  shareFacebook = () =>
    window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
      "facebook-share-dialog",
      this.sharingOpts()
    );

  shareTwitter = () =>
    window.open(
      "https://twitter.com/share",
      "twitter-share-dialog",
      this.sharingOpts()
    );

  handleGoBack = () => {
    Router.push(`/${this.props.org.odn}/e/${this.props.event.id}`);
  };

  render() {
    const {
      status,
      router,
      event,
      org,
      date,
      wrToken,
      visitor,
      intl: { formatMessage },
    } = this.props;

    if (status && status === 423)
      return <NotPublished event={event} org={org} />;
    if (!event || !org || !date) return <FullpageLoading />;
    if (
      date &&
      moment(date.starts_at).subtract(date.sale_ends_min_before, "minutes") <
        moment()
    )
      return <SalesClosed date={date} event={event} org={org} />;
    if (date && date.sold_out)
      return <SoldOut date={date} event={event} org={org} />;
    if (date && date.pub_available_qty < 1)
      return <SoldOut date={date} event={event} org={org} />;
    if (date && date.cancelled && process.env.HZL_INST)
      return <Cancelled date={date} event={event} org={org} />;
    if (date && date.cancelled && !process.env.HZL_INST)
      return <DateNotAvailable date={date} event={event} org={org} />;

    if (
      date &&
      date.tt_sale_starts_at &&
      moment(date.tt_sale_starts_at) > moment()
    )
      return <EventSaleCountdown event={event} date={date} />;

    if (org && org.portal && org.portal.wr && (!visitor || visitor.pos > 0))
      return <WaitingRoom event={event} date={date} />;

    return (
      <div>
        <NextSeo
          title={formatMessage(messages.ticketShop, org)}
          description={formatMessage(messages.buyTicketsFor, {
            name: event.title,
          })}
          canonical={`${basename}/${router.asPath}`}
          openGraph={{
            url: `${basename}/${router.asPath}`,
            title: event.title,
            description: formatMessage(messages.buyTicketsFor, {
              name: event.title,
            }),
            images: [
              {
                url: this.eventImgSrc(event),
              },
            ],
            site_name: "Ticketteer - Buy Tickets online",
          }}
          twitter={{
            handle: org.social.twitter_user || undefined,
            site: org.social.twitter_user || undefined,
            cardType: "summary_large_image",
          }}
        />
        <Head>
          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Head>
        <Background
          imgSrc={this.eventImgSrc(event)}
          className="event-date-bg"
        />
        <Menu date={date} />
        <Container>
          <TicketSettingsForm date={date} org={org} />
          <AvailableTicketsListing id={this.props.id} date={date} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  status: makeSelectResponseStatus(),
  visitor: makeSelectWaitingRoomVisitor(),
  date: makeSelectDateById((props) => props.id),
  event: makeSelectEventByDateId((props) => props.id),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchDateById,
      fetchWaitingRoomVisitor,
    },
    dispatch
  ),
});

const enhance = flowRight(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(EventIndex);
